import { Skeleton } from "@/components/ui/skeleton";

const SKELETON_CARD_COUNT = 3;
const SKELETON_CARD_KEYS = Array.from(
  { length: SKELETON_CARD_COUNT },
  (_, index) => `card-${index}`,
);

/** Placeholder that mirrors the loaded credentials tab so the panel does not
 * shift when content arrives. Rendered inside the tab body, which already
 * supplies the padding and background. */
export function CredentialPanelSkeleton({
  showPrimarySourceRuns = false,
}: {
  showPrimarySourceRuns?: boolean;
}) {
  return (
    <div role="status" aria-busy="true" className="space-y-4">
      <span className="sr-only">Loading provider credentials…</span>
      <div aria-hidden="true" className="space-y-4">
        {showPrimarySourceRuns && (
          <div className="space-y-3 rounded-xl border border-slate-200 bg-white p-4">
            <div className="flex items-center justify-between gap-3">
              <Skeleton className="h-4 w-40" />
              <Skeleton className="h-8 w-28" />
            </div>
            <Skeleton className="h-16 rounded-xl" />
          </div>
        )}
        <Skeleton className="h-20 rounded-xl" />
        {SKELETON_CARD_KEYS.map((key) => (
          <div
            key={key}
            className="space-y-3 rounded-xl border border-slate-200 bg-white p-4"
          >
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        ))}
      </div>
    </div>
  );
}
